// Canonical client engagement pipeline.
//
// `companies.stage` (Client category) must hold one of these values — they are
// the dashboard pipeline buckets, the ClientDetail stage dropdown, and the MCP
// `stage` enum. Order matters: it is the display order everywhere.
export const CLIENT_STAGES = [
  "Prospecting",
  "Engagement Letter",
  "Preparation",
  "Active Marketing",
  "Under LOI",
  "Due Diligence",
  "Closing",
] as const;

export type ClientStage = (typeof CLIENT_STAGES)[number];

// Client lifecycle status. Free text is NOT allowed here — deal narrative
// belongs in notes. Enforced by PATCH /api/companies/:id and the MCP tools.
export const CLIENT_STATUSES = ["Active", "On Hold", "Closed"] as const;

export type ClientStatus = (typeof CLIENT_STATUSES)[number];

export function clientStageIndex(stage: string | null | undefined): number {
  const idx = CLIENT_STAGES.indexOf((stage ?? "") as ClientStage);
  return idx === -1 ? CLIENT_STAGES.length : idx; // unknown/null sorts last
}
